import { useEffect, useState } from 'react'

import { Button, Icon, Layout } from '@loadsmart/miranda-react'

import { AnalyticsEvent } from 'core/analytics/events'
import { useAnalytics } from 'core/analytics/useAnalytics'
import { RequestType } from 'core/domain/RequestType'
import ZendeskDialog from 'core/ui/components/zendesk/TryNowZendeskDialog'

import {
  StyledActions,
  StyledAnswer,
  StyledAside,
  StyledCaption,
  StyledColumn,
  StyledExample,
  StyledHeadline,
  StyledLede,
  StyledQuestion,
  StyledTable,
} from './AssistantLead.styles'

const REQUEST_LABEL = 'Request beta access'

const EXAMPLE_ROWS = [
  { warehouse: 'Atlanta DC', appointments: 412, onTime: '88%' },
  { warehouse: 'Columbus', appointments: 356, onTime: '91%' },
  { warehouse: 'Reno', appointments: 297, onTime: '84%' },
]

export default function AssistantLead() {
  const { track } = useAnalytics()
  const [isDialogOpen, setIsDialogOpen] = useState(false)

  useEffect(() => {
    track(AnalyticsEvent.OpenAssistant)
  }, [track])

  function openRequestForm() {
    track(AnalyticsEvent.OpenAssistantLeadForm, { Source: 'Hero' })
    setIsDialogOpen(true)
  }

  return (
    <StyledColumn gap="spacing-8">
      <Layout.Stack gap="spacing-4">
        <StyledHeadline>Ask your freight and dock data a question and get the answer.</StyledHeadline>
        <StyledLede>
          The Assistant reads your own reports with your own permissions. It shows the rows behind
          every answer, so you can check them.
        </StyledLede>
        <StyledActions>
          <Button variant="primary" leading={<Icon name="send" />} onClick={openRequestForm}>
            {REQUEST_LABEL}
          </Button>
          <StyledAside>The beta is open to Opendock customers by request.</StyledAside>
        </StyledActions>
      </Layout.Stack>

      <StyledExample>
        <StyledQuestion>How many appointments did each warehouse have last week?</StyledQuestion>
        <StyledAnswer>
          <p>Atlanta DC was busiest with 412 appointments. Reno had the lowest on-time rate.</p>
          <StyledTable>
            <thead>
              <tr>
                <th scope="col">Warehouse</th>
                <th scope="col">Appointments</th>
                <th scope="col">On time</th>
              </tr>
            </thead>
            <tbody>
              {EXAMPLE_ROWS.map(row => (
                <tr key={row.warehouse}>
                  <td>{row.warehouse}</td>
                  <td>{row.appointments}</td>
                  <td>{row.onTime}</td>
                </tr>
              ))}
            </tbody>
          </StyledTable>
        </StyledAnswer>
        <StyledCaption>Example with sample data.</StyledCaption>
      </StyledExample>

      <ZendeskDialog
        requestType={RequestType.Question}
        open={isDialogOpen}
        onClose={() => setIsDialogOpen(false)}
        title={REQUEST_LABEL}
        description="Tell us where to reach you. We will contact you about opening the Assistant on your Opendock data."
      />
    </StyledColumn>
  )
}
